"use client";

import React, { useEffect } from "react";

interface LoanTenureSelectorProps {
  carYear: number;
  selectedYear?: number;
  onChange?: (year: number) => void;
}

const LoanTenureSelector: React.FC<LoanTenureSelectorProps> = ({ carYear, selectedYear, onChange }) => {
  const carAge = new Date().getFullYear() - carYear;
  const getMaxAllowedYears = (year: number): number => {
    if (year >= 2018) return 5;
    if (year === 2017) return 4;
    if (year === 2016) return 3;
    return 1; // For cars older than 6 years
  };

  const yearOptions = [1, 2, 3, 4, 5];
  const maxAllowedYears = getMaxAllowedYears(carYear);

  const isDisabled = (year: number): boolean => {
    return year > maxAllowedYears;
  };

  const handleYearClick = (year: number) => {
    if (!isDisabled(year)) {
      onChange?.(year);
    }
  };

  // Effect to select highest available tenure if current selection is disabled
  useEffect(() => {
    if (!selectedYear || isDisabled(selectedYear)) {
      onChange?.(maxAllowedYears);
    }
  }, [carYear, maxAllowedYears, selectedYear, onChange]);

  return (
    <div>
      <h4 className="mt-5 font-medium">I can repay the loan in (years)*</h4>
      <div className="mt-4 flex w-full space-x-3">
        {yearOptions.map((year) => (
          <div
            key={year}
            onClick={() => handleYearClick(year)}
            className={`flex h-14 w-14 cursor-pointer items-center justify-center rounded-xl font-inter text-base font-bold transition-colors ${
              isDisabled(year)
                ? "cursor-not-allowed bg-gray-200 text-gray-400"
                : selectedYear === year
                  ? "bg-primary-light text-primary"
                  : "bg-secondary hover:bg-primary-light hover:text-primary"
            } `}
          >
            {year}
          </div>
        ))}
      </div>
      <div className="mt-2 text-sm text-gray-500">
        {carAge > 3 && `For ${carAge} year old cars, maximum loan tenure is ${maxAllowedYears} years`}
      </div>
    </div>
  );
};

export default LoanTenureSelector;
